/**
 * @MX:ANCHOR: SPEC-011 REQ-010/REQ-013 csrf cookie read + bootstrap helpers.
 * @MX:REASON: Double-submit pattern central point — consumed by login submit, logout button, and tests.
 */

/**
 * Parse `document.cookie`-style string and extract value of `csrf` cookie.
 * Returns undefined when cookie absent.
 *
 * Кук с именем `csrf` в браузере может оказаться НЕСКОЛЬКО (разные path/domain
 * от прежних версий), и одна из них бывает нечитаемой — с оборванной
 * %-последовательностью. `decodeURIComponent` на такой куке бросает URIError, а
 * читают эту функцию прямо из обработчика ввода на экране входа: раньше бросок
 * замораживал экран (клетки заблокированы, ошибки нет, запрос не уходит).
 * Поэтому берём первую куку, которая раскодировалась; если ни одна не годится —
 * считаем, что куки нет, и вызывающий возьмёт свежую через bootstrapCsrf.
 */
export function getCsrfCookieValue(cookieString?: string): string | undefined {
  const source =
    cookieString ??
    (typeof document !== "undefined" ? document.cookie : "");
  if (!source) return undefined;
  for (const match of source.matchAll(/(?:^|; )csrf=([^;]*)/g)) {
    try {
      return decodeURIComponent(match[1]);
    } catch {
      continue;
    }
  }
  return undefined;
}

/**
 * Call backend bootstrap endpoint to obtain a fresh csrf cookie. Sends credentials.
 * Resolves on 204 (or any 2xx). Rejects on non-ok / non-204.
 */
export async function bootstrapCsrf(): Promise<void> {
  const res = await fetch("/api/auth/csrf", {
    method: "GET",
    credentials: "include",
  });
  if (!res.ok && res.status !== 204) {
    throw new Error(`CSRF bootstrap failed: ${res.status}`);
  }
}
